import endMailListLoadDatapoint from './endMailListLoadDatapoint';
import {
    getStore as getListViewStore,
    isPriorityView,
    type MailFolderTableQuery,
} from 'owa-mail-list-store';
import { logPrioritizeTelemetryEvent } from 'owa-copilot-telemetry/lib/prioritizeTelemetryLogger';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { isPrioritizeOnDeliveryOn } from 'owa-copilot-settings-utils';

export default function onMailListLoaded(componentRendered: string, tableViewId: string): void {
    endMailListLoadDatapoint(componentRendered, tableViewId, false /* shouldInvalidate */);

    const tableView = getListViewStore().tableViews.get(tableViewId) ?? null;
    if (tableView && isPriorityView(tableView.tableQuery as MailFolderTableQuery)) {
        const mailboxInfo = getMailboxInfo(tableView);
        logPrioritizeTelemetryEvent('PrioritizeViewOpened', mailboxInfo, {
            isPrioritizeOnDeliveryOn: isPrioritizeOnDeliveryOn(mailboxInfo),
        });
    }
}
